import { Injectable } from '@angular/core';
import { Lab } from '../models/lab.model';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';

@Injectable({
  providedIn: 'root'
})
export class LabService extends GridService<Lab> {
  constructor(http: HttpClient) {
    super('Lab', http);
  }
}
